// Remembers the page a logged-out user tried to open (e.g. the "View Call Details" link in the
// agent/keyword emails) so Login can send them there instead of the default landing page.
// sessionStorage, not localStorage — survives the localStorage.clear() on a 401 logout and is
// scoped to the tab that opened the link.
const KEY = "postLoginRedirect";

// Only same-app paths ("/user/..."), never "//host" or a full URL — no open redirect.
const isSafePath = (path) => typeof path === "string" && path.startsWith("/") && !path.startsWith("//") && !path.startsWith("/login");

export const savePostLoginRedirect = (path) => {
  try {
    if (isSafePath(path) && path !== "/") sessionStorage.setItem(KEY, path);
  } catch {}
};

// Returns the saved path (and clears it), or null.
export const consumePostLoginRedirect = () => {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return isSafePath(path) ? path : null;
  } catch {
    return null;
  }
};
